// The few glyphs the app draws itself: inline SVG at 1em, stroked in
// currentColor so they take the colour of whatever text they sit in. They
// replaced an icon font that shipped 2,000 glyphs for these three.
interface IconProps {
	size?: string
}

const attrs = (size: string) => ({
	width: size,
	height: size,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	"stroke-width": 2.25,
	"stroke-linecap": "round" as const,
	"stroke-linejoin": "round" as const,
})

export function IconX({ size = "1em" }: IconProps) {
	return (
		<svg {...attrs(size)} aria-hidden="true">
			<path d="M6 6l12 12M18 6L6 18" />
		</svg>
	)
}

export function IconCheck({ size = "1em" }: IconProps) {
	return (
		<svg {...attrs(size)} aria-hidden="true">
			<path d="M5 12.5l4.5 4.5L19 7" />
		</svg>
	)
}

export function IconUndo({ size = "1em" }: IconProps) {
	return (
		<svg {...attrs(size)} aria-hidden="true">
			<path d="M9 14L4 9l5-5" />
			<path d="M4 9h9a6 6 0 0 1 0 12h-3" />
		</svg>
	)
}
